import axios from "axios";
import { api, apiAuth } from "../../../services/ApiService";
import { createRequest } from "../../../helpers/RequestHelper";
import getAddressByCEP from "../../../helpers/SoapCep";

export function buscarGRUsPorCPFPorPagina(url, onSuccess, onError) {
  console.log("URL "+url)
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: url,
    onSuccess,
    onError
  });
}

export function buscarHistoricoPorNome(
  nome,
  n_itens,
  pagina,
  onSuccess,
  onError
) {
  n_itens = n_itens < 10 ? 10 : n_itens;
  const path = `/historico?filtro=${nome}&size=${n_itens}&page=${pagina - 1}`;
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: path,
    onSuccess,
    onError
  });
}

export function buscarCustoBoleto(
  onSuccess,
  onError) {
  const path = "/historico/custo";
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: path,
    onSuccess,
    onError
  })
}

export function buscarHistorico(url, onSuccess, onError) {
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: url,
    onSuccess,
    onError
  });
}

export function buscarGRU(id, onSuccess, onError) {
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: "/grus/" + id,
    onSuccess,
    onError
  });
}

export function buscarGRUAtiva(id, onSuccess, onError) {
  return createRequest({
    api: api,
    method: "GET",
    path: "/grus/active/" + id,
    onSuccess,
    onError
  });
}

export function buscarGRUsAtivas(onSuccess, onError) {
  return createRequest({
    api: api,
    method: "GET",
    path: "/grus/active",
    onSuccess,
    onError
  });
}

// http://192.168.24.119:9000/api/historico/grus/8?size=10&page=0&filtro=
export function buscarInscritosDeUmaGRUPorPagina(
  idGRU,
  n_itens,
  pagina,
  campo_filtro,
  onSuccess,
  onError
) {
  n_itens = n_itens < 10 ? 10 : n_itens;
  const path = `/historico/grus/${idGRU}/?size=${n_itens}&sort=dataSubmissao,desc&page=${pagina -
    1}&filtro=${campo_filtro}`;
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: path,
    onSuccess,
    onError
  });
}

export function buscarInscritosDeUmaGRU(url, onSuccess, onError) {
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: url,
    onSuccess,
    onError
  });
}

export function buscarInscritosDeUmaGruSortDesc(url, onSuccess, onError) {
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: url + "&sort=dataSubmissao,desc",
    onSuccess,
    onError
  });
}

export function buscarSubmissoesGRUPorCPF(cpf, onSuccess, onError) {
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: "/historico?access=" + cpf,
    onSuccess,
    onError
  });
}

export function enviarSubmissaoGRU(idForm, data, onSuccess, onError) {
  return createRequest({
    api: api,
    method: "POST",
    path: "/historico/" + idForm,
    data: data,
    onSuccess,
    onError
  });
}

export function apagarSubmissaoGRU(idForm, onSuccess, onError) {
  return createRequest({
    api: api,
    method: "DELETE",
    path: "/historico/" + idForm,
    onSuccess,
    onError
  });
}

// localhost:9000/api/historico/info/{idGru}
export function infoGRU(idGru, onSuccess, onError) {
  const path = `/historico/info/${idGru}`;
  return createRequest({
    api: apiAuth,
    method: "GET",
    path,
    onSuccess,
    onError
  });
}

// localhost:9000/api/historico/{id}/boleto
// export function downloadBoleto(idHistorico, onSucessDownloadBoleto, onErrorDownloadBoleto){
//     const path = `/historico/${idHistorico}/boleto`
//     downloadArquivoAjaxComNotificacao(process.env.REACT_APP_URL_API + path, onSucessDownloadBoleto, onErrorDownloadBoleto, idHistorico)
// }

export function buscaCEP(cep, onSuccess, onError) {
  let api = axios.create({ baseURL: "https://viacep.com.br" });
  const path = `/ws/${cep}/json/`;
  return createRequest({
    api: api,
    method: "GET",
    path,
    onSuccess,
    onError
  });
}

export function consultaCEP(cep, onSuccess, onError) {
  const url =
    "https://cors-anywhere.herokuapp.com/https://apps.correios.com.br/SigepMasterJPA/AtendeClienteService/AtendeCliente?wsdl";
  return getAddressByCEP(cep, url).then(onSuccess, onError);
}



// WEBPACK FOOTER //
// ./src/view/gru/actions/GRUActions.js